import { connect } from 'react-redux';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import LoanRepaymentReport from '../reports/loanRepaymentReport';
import {
  getLoanRepaymentReport,
  getLoanRepaymentReportCsv,
} from '../reports/actions';
import fetchData from '../reports/hoc/fetchData';

const mapStateToProps = state => ({
  shop: state.auth.shop,
  loanRepaymentReport: state.reports.loanRepaymentReport,
});

const mapDispatchToProps = {
  getLoanRepaymentReport,
  getLoanRepaymentReportCsv,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    getReport: props => () => props.getLoanRepaymentReport(props.shop),
    csv: props => () => props.getLoanRepaymentReportCsv(props.shop),
  }),
  fetchData
);

export default enhance(LoanRepaymentReport);
